import OverlappingMarkup from '@modules/feedback/components/FeedbackDetails/FeedbackDetailsConversation/OverlappingMarkup';
import FeedbackHighlighter from '@modules/feedback/components/FeedbackHighlighter/FeedbackHighlighter';
import { Highlight } from '@modules/feedback/types';
import { getPIIHighlightStyling } from '@modules/feedback/utils';

interface HighlightedFeedbackTextProps {
  showOriginalLanguage: boolean;
  text: string;
  highlights: Highlight[];
  msgIndex?: number;
}

export const HighlightedFeedbackText = ({
  showOriginalLanguage,
  text,
  highlights,
  msgIndex,
}: HighlightedFeedbackTextProps) => {
  if (showOriginalLanguage) {
    const piiHighlightStyling = getPIIHighlightStyling(text);

    return <OverlappingMarkup text={text} styling={piiHighlightStyling} />;
  }

  return (
    <FeedbackHighlighter
      text={text}
      highlights={highlights}
      msgIndex={msgIndex}
    />
  );
};
